import { AlertTriangle, CheckCircle2, ShieldCheck } from 'lucide-react';
import { Pill } from '@/components/surface/ui';
import type { BackupTrust } from '@/types/api';

/**
 * How far a backup has been proved. Nothing for `unverified`: every backup taken before verification
 * existed is unverified, and a wall of grey badges on old rows would bury the ones that matter.
 */
export function TrustBadge({ trust }: { trust: BackupTrust }) {
  if (trust === 'restorable') {
    return (
      <Pill tone="success" icon={ShieldCheck} title="Restored into a scratch database and read back successfully">
        Restore tested
      </Pill>
    );
  }

  if (trust === 'stored') {
    return (
      <Pill tone="muted" icon={CheckCircle2} title="Confirmed at its destination, the size that was written">
        Confirmed stored
      </Pill>
    );
  }

  if (trust === 'failed') {
    return (
      <Pill
        tone="danger"
        icon={AlertTriangle}
        title="A check proved this copy cannot be relied on. It no longer counts towards the copies you keep."
      >
        Failed verification
      </Pill>
    );
  }

  return null;
}
